import axios from '../utilities/axios'

async function getTerms() {
  return axios.get('/api/v1/terms')
}

export default {
  getTerms,
}
